import { combineReducers } from 'redux'
import { FormState, reducer as formReducer } from 'redux-form'
import { IPriceConfiguration } from '../models/Price'
import { IPrices } from '../models/Price/mappers/mapResponseToPriceGrid'
import bookingCalendarReducer, {
  IBookingCalendarStore,
} from './bookingCalendar'
import currency, { ICurrencyStore } from './currency'
import search, { ISearchStore } from './search'
import synchronize, { ISynchronizeStore } from './synchronize'
import userAccountReducer, { IUserAccountStore } from './userAccount'
import userObject, { IUserObjectStore } from './userObject'
import reservationsList, { IReservationsList } from './reservationsList'
import provenances, { IProvenancesStore } from './provenances'
import paymentDictionary, { IPaymentDictionaryStore } from './paymentDictionary'
import templates, { ITemplatesStore } from './templates'
import events, { IEventsStore } from './events'
import notificationsService, {
  INotificationsService,
} from './notificationService'
import modal, { IModalStore } from './modals'
import invoice, { IInvoiceStore } from './invoice'
import price, { IPriceHint } from './price'
import stats, { IStatsStore } from './stats'
import integration, { IIntegrationStore } from './airbnb/index'
import boxBuyIntegration, { IBoxBuyIntegrationStore } from './boxbuy/index'
import clients, { IClientStore } from './clients'
import tasks, { ITaskStore } from './tasks'
import photos, { IPhotosStore } from './photos'
import widget, { IWidgetStore } from './widget'
import ical, { IIntegrationStore as ICalStore } from './ical'
import facilities, { IFacilitiesStore } from './facilities'
import booking, { IIntegrationStore as IBookingStore } from './booking'
import rentLicenses, { IRentLicensesStore } from './rentLicenses'
import overview, { IOverviewStore } from './overview'
import employees, { IEmployeesStore } from './employees'
import priceEdit, { IPriceEditStore } from './priceEdit'
import { PriceSettingsTab } from '../containers/PriceSettingsContent/PriceSettingsNavigator'

export default combineReducers({
  bookingCalendar: bookingCalendarReducer,
  clients,
  currency,
  overview,
  events,
  form: formReducer,
  priceEdit: priceEdit,
  invoice,
  modal: modal,
  notificationsService,
  object: userObject,
  paymentDictionary,
  photos: photos,
  price,
  provenances,
  reservationsList,
  search,
  stats,
  synchronize,
  tasks,
  templates,
  userAccount: userAccountReducer,
  widget,
  integration,
  boxBuyIntegration,
  facilities,
  ical,
  booking,
  rentLicenses: rentLicenses,
  employees,
})

export interface IStore {
  bookingCalendar: IBookingCalendarStore
  clients: IClientStore
  currency: ICurrencyStore
  form: FormState
  object: IUserObjectStore
  invoice: IInvoiceStore
  paymentDictionary: IPaymentDictionaryStore
  provenances: IProvenancesStore
  synchronize: ISynchronizeStore
  templates: ITemplatesStore
  userAccount: IUserAccountStore
  reservationsList: IReservationsList
  events: IEventsStore
  tasks: ITaskStore
  search: ISearchStore
  stats: IStatsStore
  ical: ICalStore
  booking: IBookingStore
  photos: IPhotosStore
  rentLicenses: IRentLicensesStore
  widget: IWidgetStore
  employees: IEmployeesStore
  overview: IOverviewStore
  integration: IIntegrationStore
  boxBuyIntegration: IBoxBuyIntegrationStore
  priceEdit: IPriceEditStore
  price: {
    prices: IPrices[]
    config: IPriceConfiguration
    loadingGlobal: boolean
    loading: boolean
    hint: IPriceHint
    startDate: Date
    finishDate: Date
    selectedDate: Date
    configLoading: boolean
    onboardModal: boolean
    onboardCalendarModal: boolean
    onboardPriceModal: boolean
    priceSettingsTab: PriceSettingsTab
    diff: boolean
    settingsData: any
    closeModal: boolean
    action: string
    errors: any
    expanded: any
    feeModal: any
    newPrices: any
    newPricesLoading: boolean
    editRoomOpen: boolean
    editRoomId: any
    roomSettings: any
    roomsExpanded: boolean
    int: any
    roomSettingsGlobal: any
    airbnbSettingsErrors: any
    bookingSettingsErrors: any
    editRoomPrice: boolean
    provisionPopout: boolean
    scroll: {
      clientWidth: number
      scrollLeft: number
      scrollWidth: number
      scrollTop: number
    }
    priceGridFilter: {
      channels: { airbnb: boolean; bedbooking: boolean; booking: boolean }
      capacities: Record<number, boolean>
    }
    copyPricesFinished: boolean
    copyPricesError: string | null
  }
  notificationsService: INotificationsService
  modal: IModalStore
  facilities: IFacilitiesStore
}
